/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobals = exports.setGlobals = exports.formData = exports.globals = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.setFormData = setFormData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globals = exports.globals = {}; // udrzuje globalni nastaveni
var formData = exports.formData = void 0; // udrzuje puvodni json formularove data

function setFormData(newData) {
  exports.formData = formData = newData; // ulozime json data jako string
}

var setGlobals = exports.setGlobals = function setGlobals(globalsConstants) {
  (0, _assign2.default)(globals, globalsConstants);
};

var getGlobals = exports.getGlobals = function getGlobals(item) {
  if (typeof globals[item] !== 'undefined') return globals[item];
  return null;
};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(5)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(1)
  , ctx       = __webpack_require__(18)
  , hide      = __webpack_require__(20)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(21)
  , IE8_DOM_DEFINE = __webpack_require__(22)
  , toPrimitive    = __webpack_require__(24)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(9)
  , defined = __webpack_require__(10);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(30);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = undefined;

var _classCallCheck2 = __webpack_require__(44);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(45);

var _createClass3 = _interopRequireDefault(_createClass2);

var _globals = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modal ########################################################################################################
var $modal = void 0;

var Modal = exports.Modal = function () {
  function Modal() {
    var newText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "sampleText";
    (0, _classCallCheck3.default)(this, Modal);

    //this.modal += 1;
    console.log('initialising modal:', 'modal');
    this.text = newText;

    $modal = $('<div />', {
      'id': '',
      'class': 'modal fade',
      'tabindex': '-1',
      'role': 'dialog'
    });

    var $modalDialog = $('<div />', {
      'id': 'modal-dialog-a',
      'class': 'modal-dialog',
      'role': 'document'
    }).appendTo($modal);

    var $modalContent = $('<div />', {
      'id': 'modal-content-a',
      'class': 'modal-content',
      'html': '<div class="modal-body">\n                ' + this.text + '\n              </div>'
    }).appendTo($modalDialog);

    var $modalFooter = $('<div />', {
      'class': 'modal-body text-center',
      'id': 'btn-holder-a'
    }).appendTo($modalContent);

    $('<input />', { //agree btn
      type: 'button',
      value: 'Ok',
      'data-dismiss': 'modal',
      'class': 'btn btn-primary',
      'id': 'ok-a'
    }).click(function (e) {
      return function (e) {
        e.preventDefault();
        $('#newsletter-form .checkbox-custom-label').removeClass('error'); // zrusime error oznaceni vsech checkboxu, ze nebyl zadny vyplnen
      };
    }()).appendTo($modalFooter);
    //$modalWrapper.appendTo($('body'));
    $modal.appendTo('body');
  }

  (0, _createClass3.default)(Modal, [{
    key: 'setText',
    value: function setText(text) {
      this.text = text;
    }
  }, {
    key: 'show',
    value: function show() {
      $modal.modal('show');
    }
  }]);
  return Modal;
}();
// Modal ########################################################################################################

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _main = __webpack_require__(14);

var _main2 = _interopRequireDefault(_main);

var _globals = __webpack_require__(0);

var _submit = __webpack_require__(41);

var _modal = __webpack_require__(49);

var _modalCls = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import stylu , potreba uvest pro webpack aby zpracoval styly!!!
var $targetElement = void 0;
var groupHash = void 0,
    userHash = void 0;
var email_disabled = void 0;

// ### INIT ################################################################################################################################################################
var init = function init(opts, target) {
  console.log(opts);
  $targetElement = target.empty();
  var defaults = {
    name: 'approval-form',
    prefix: 'approval-',
    localData: false,
    recaptchaKey: '6LcO71YUAAAAABhmIE0quFuVCkkskfCriCsxkNXm',
    groupHash: '',
    dataPath: 'https://dpl-dev-ares-qa.sa.cz/webapi/api/signatures/config',
    //      dataPath: 'https://webapi.sa.cz/services/api/signatures/config',
    updatePath: 'https://dpl-dev-ares-qa.sa.cz/webapi/api/signatures/update',
    //      updatePath: 'https://webapi.sa.cz/services/api/signatures/update',
    btnColor: '#00b5d7',
    checkTextColor: '#00b5d7',
    unsubscribe: false
  };

  opts = $.extend({}, defaults, opts);
  (0, _globals.setGlobals)(opts);

  if (_globals.globals.localData) {
    // nacitej lokalni json soubor pro debug
    _globals.globals.dataPath = './json/data.json';
  }

  userHash = getUrlParameter('u');
  if (typeof userHash === 'undefined') {
    userHash = '';
  }

  if (typeof _globals.globals.groupHash !== 'undefined' && _globals.globals.groupHash !== '') {
    groupHash = _globals.globals.groupHash;
  }
  var dataUrl = _globals.globals.dataPath + '/' + groupHash + '/' + userHash;

  //userHash = "21cf8a98-6e48-11e8-adc0-fa7ae01bbebc";
  $.getJSON(dataUrl).then(function (data) {
    (0, _globals.setFormData)(data);
    renderForm();
  }).fail(function (err) {
    console.error('Error loading layer data', err);
  });
};
// ### INIT ################################################################################################################################################################
//
// ### FORM ################################################################################################################################################################
var renderForm = function renderForm() {
  // tvorba checkboxu

  //  console.log('formdata',formData);
  var $form = $('<form />', {
    action: '/',
    id: 'approval-form',
    name: 'approval-form',
    'class': 'approval-form'
  });
  $form.appendTo($targetElement);
  //generateModal('Musíte zvolit zda-li souhlasíte či ne.').appendTo($form);


  var $contentBefore = $('<p />', {
    id: _globals.globals.prefix + 'content-before',
    'class': _globals.globals.prefix + 'content-before',
    html: _globals.formData.options.text_before
  }).appendTo($form);

  var $radio_yes = $('<input />', {
    type: 'radio',
    name: 'approval-radio-group',
    value: true,
    'class': 'radio-custom',
    checked: _globals.formData.sources[0].checked,
    id: _globals.globals.prefix + 'radio-yes'
  }).on('click', function (e) {}).appendTo($form);

  var $label_yes = $('<label />', {
    html: 'Souhlasím',
    css: { 'color': _globals.globals.checkTextColor },
    'class': 'radio-custom-label',
    for: _globals.globals.prefix + 'radio-yes'
  }).appendTo($form);

  var $radio_no = $('<input />', {
    type: 'radio',
    name: 'approval-radio-group',
    value: false,
    'class': 'radio-custom',
    checked: _globals.formData.sources[0].checked === false ? true : false,
    id: _globals.globals.prefix + 'radio-no'
  }).on('click', function (e) {}).appendTo($form);

  var $label_no = $('<label />', {
    html: 'Nesouhlasím',
    css: { 'color': _globals.globals.checkTextColor },
    'class': 'radio-custom-label',
    for: _globals.globals.prefix + 'radio-no'
  }).appendTo($form);

  $('<br />', {}).appendTo($form);

  var $contentAfter = $('<div />', {
    'id': _globals.globals.prefix + 'content-after',
    'class': _globals.globals.prefix + 'content-after',
    'html': _globals.formData.options.text_after
  }).appendTo($form);

  var $validation = $('<input />', {
    'type': 'text',
    'id': 'phone',
    'name': 'phone',
    'class': 'approval-phone',
    'css': {
      'display': 'none'
    },
    'value': ''
  }).appendTo($form);

  var $submitWrapper = $('<div />', {
    'class': 'btn-wrapper'
  }).appendTo($form);

  var $submit = $('<input />', {
    type: 'submit',
    'name': 'approval_submit',
    'css': {
      'background-color': _globals.globals.btnColor,
      'opacity': 1
    },
    'class': 'approval_submit',
    'value': 'Potvrdit'
  }).hover(function () {
    $(this).css("opacity", "0.85");
  }, function () {
    $(this).css("opacity", "1");
  });

  $form.submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    (0, _submit.formSubmit)();
  });
  $submit.appendTo($submitWrapper);

  /*   const dt = new Date();
    let now = 'Dne ' + dt.getDate().toString() + '. ' + dt.getMonth().toString() + '. ' + dt.getFullYear().toString();
    $('<div />', {
      html: now
    }).appendTo($form); */
};
// ### FORM ################################################################################################################################################################

(function ($) {
  $.support.cors = true;

  $.fn.extend({
    approvalForm: function approvalForm(opts) {
      init(opts, this);
    }
  });
})(jQuery);

// ### FN ################################################################################################################################################################
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};
// ### FN ################################################################################################################################################################

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(16), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
module.exports = __webpack_require__(1).Object.assign;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(6);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(26)});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(7)
  , createDesc = __webpack_require__(25);
module.exports = __webpack_require__(2) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(2) && !__webpack_require__(5)(function(){
  return Object.defineProperty(__webpack_require__(23)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(27)
  , gOPS     = __webpack_require__(38)
  , pIE      = __webpack_require__(39)
  , toObject = __webpack_require__(40)
  , IObject  = __webpack_require__(9)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(5)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(28)
  , enumBugKeys = __webpack_require__(37);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(29)
  , toIObject    = __webpack_require__(8)
  , arrayIndexOf = __webpack_require__(31)(false)
  , IE_PROTO     = __webpack_require__(34)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(8)
  , toLength  = __webpack_require__(32)
  , toIndex   = __webpack_require__(33);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(11)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(11)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(35)('keys')
  , uid    = __webpack_require__(36);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 38 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(10);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formSubmit = undefined;

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

var _globals = __webpack_require__(0);

var _modalCls = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formSubmit = exports.formSubmit = function formSubmit() {

  //generateModal('Musíte zvolit zda-li souhlasíte či ne.').appendTo($form);  
  if (!$('#phone')[0].value) {
    // error captcha robot vyplnil skryte pole
    var approved = $('input[name=approval-radio-group]:checked', '#approval-form').val() == 'true';
    if ($('input[name=approval-radio-group]:checked', '#approval-form').val() !== 'true' && $('input[name=approval-radio-group]:checked', '#approval-form').val() !== 'false') {
      var UncheckedModal = new _modalCls.Modal("Zvolte prosím jednu z možností.");
      UncheckedModal.show();
    } else {
      _globals.formData.sources[0].checked = approved;
      console.log(approved);
      console.log(_globals.formData);

      if (1) {
        // odeslat????
        var parsed = (0, _stringify2.default)(_globals.formData);
        $.ajax({
          type: "POST",
          cache: false,
          url: _globals.globals.updatePath,
          data: parsed,
          contentType: 'application/json',
          success: function success(response) {
            var SuccessModal = new _modalCls.Modal("Děkujeme za vyplnění formuláře.");
            SuccessModal.show();
            //window.location.replace('/podekovani.html');
          },
          error: function error(e) {
            console.log('error', e);
            alert('Došlo k chybě při komnunikaci se serverem\n');
          }
        });
      }
    }
  } else {
    console.log('cpt error');
  }
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(1)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(46);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(47), __esModule: true };

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(2), 'Object', {defineProperty: __webpack_require__(7).f});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateModal = generateModal;

var _globals = __webpack_require__(0);

// Modal ########################################################################################################
function generateModal(text) {

  var $modal = $('<div />', {
    'id': 'modal-a',
    'class': 'modal fade',
    'tabindex': '-1',
    'role': 'dialog'
  });

  var $modalDialog = $('<div />', {
    'id': 'modal-dialog-a',
    'class': 'modal-dialog',
    'role': 'document'
  }).appendTo($modal);

  var $modalContent = $('<div />', {
    'id': 'modal-content-a',
    'class': 'modal-content',
    'html': '<div class="modal-body">\n                  ' + text + '\n                </div>'
  }).appendTo($modalDialog);

  var $modalFooter = $('<div />', {
    'class': 'modal-body text-center',
    'id': 'btn-holder-a'
  }).appendTo($modalContent);

  $('<input />', { //agree btn
    type: 'button',
    value: 'Ok',
    'data-dismiss': 'modal',
    'class': 'btn btn-primary',
    'id': 'ok-a'
  }).click(function (e) {
    return function (e) {
      e.preventDefault();
      $('#newsletter-form .checkbox-custom-label').removeClass('error'); // zrusime error oznaceni vsech checkboxu, ze nebyl zadny vyplnen
    };
  }()).appendTo($modalFooter);
  return $modal;
}
// Modal ########################################################################################################

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js